import React from 'react';
import {
  CreateButton, Datagrid, Filter, FunctionField, List, SelectInput, TextField, TextInput, TopToolbar,
} from 'react-admin';
import { Typography } from '@mui/material';
import CheckChainUsesModule, { ModuleKey } from '../../components/CheckChainUsesModule';
import FeatureIntro from '../../components/FeatureIntro';
import Permission from '../../components/Permission';
import { PERMISSIONS } from '../../constants';
import { getChainId } from '../../lib';
import ManualLinkButton from '../../manual/components/ManualLinkButton';
import { ROLETA_RESOURCE, RoletaStatus } from '../../models/roleta';
import RoletaStatusChip from './RoletaStatusChip';

const formatDate = (value?: string | null) => (value ? new Date(value).toLocaleDateString('pt-BR') : '—');

const formatCount = (value: unknown) =>
  value === null || value === undefined ? '—' : Number(value).toLocaleString('pt-BR');

const RoletaFilters = (props: any) => (
  <Filter {...props}>
    <TextInput source="q" label="Buscar nome" alwaysOn />
    <SelectInput
      source="status"
      label="Status"
      alwaysOn
      choices={RoletaStatus.roletaStatusChoices}
    />
  </Filter>
);

const ListActions = () => (
  <TopToolbar>
    {Permission({
      permission: PERMISSIONS.GIFT,
      children: (
        <FeatureIntro
          id="manual-roleta"
          title="Manual da Roleta da Sorte"
          description="Veja o passo a passo: criar a roleta, montar as fatias, cadastrar o brinde que dá giros e o brinde de prêmios, e acompanhar o resultado."
        >
          <ManualLinkButton slug="roleta" label="Manual da Roleta" />
        </FeatureIntro>
      ),
    })}
    <CreateButton />
  </TopToolbar>
);

const RoletaList: React.FC = (props: any) => {
  const chainId = getChainId();

  return (
    <CheckChainUsesModule module={ModuleKey.ROLETA}>
      <Permission permission={PERMISSIONS.GIFT}>
        <List
          {...props}
          resource={ROLETA_RESOURCE}
          filters={<RoletaFilters />}
          actions={<ListActions />}
          sort={{ field: 'startAt', order: 'DESC' }}
          filter={{ chainId }}
          hasCreate
          title="Roleta da Sorte"
        >
          <Datagrid rowClick="show" bulkActionButtons={false}>
            <FunctionField label="Status" render={(r: any) => <RoletaStatusChip status={r.status} />} />
            <TextField source="name" label="Nome" />
            <FunctionField
              label="Período"
              render={(r: any) => (
                <Typography variant="body2">
                  {formatDate(r.startAt)} até {formatDate(r.endAt)}
                </Typography>
              )}
            />
            <FunctionField
              label="Fatias"
              textAlign="center"
              render={(r: any) => formatCount(r.stats?.segmentsCount ?? r.segmentsCount ?? r.segments?.length)}
            />
            <FunctionField
              label="Giros concedidos"
              textAlign="center"
              render={(r: any) => formatCount(r.stats?.spinsGranted)}
            />
            <FunctionField
              label="Giros realizados"
              textAlign="center"
              render={(r: any) => formatCount(r.stats?.spinsUsed)}
            />
            <FunctionField
              label="Prêmios"
              textAlign="center"
              render={(r: any) => formatCount(r.stats?.prizesDelivered)}
            />
          </Datagrid>
        </List>
      </Permission>
    </CheckChainUsesModule>
  );
};

export default RoletaList;
